/*export function subscribeMessages() {
  return {
    event: 'message',
    handle: NEW_MESSAGE,
  }
}

export function unsubscribeMessages() {
  return {
    event: 'message',
    leave: true,
  }
}*/

// Types for socket actions
interface SocketAction {
  event: string;
  leave?: boolean;
  handle?: any;
  type?: "ON" | "EMIT" | "EMIT_ROOM";
  room?: string;
}

// Action creators
export const leave = (event: string): SocketAction => ({
  event: event,
  leave: true,
});

export const onMessage = (event: string, handle: any): SocketAction => ({
  event: event,
  handle: handle,
  type: "ON",
});

export const emitMessage = (event: string, handle: any): SocketAction => ({
  event: event,
  handle: handle,
  type: "EMIT",
});

export const emitRoomMessage = (
  event: string,
  handle: any,
  room: string
): SocketAction => ({
  event: event,
  handle: handle,
  room: room,
  type: "EMIT_ROOM",
});
